// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
#    Colors
   ========================================================================== */
/*\$mainColor:#d40621;
\$alphaLight:rgba(#fff, .5);
\$alphaDark:rgba(#000, .5);
\$placeholderTextLight:rgba(#fff, .7);
\$placeholderTextDark:rgba(#000, .7);

\$textLight: #fff;
\$textDark: #404040;
\$textThemes:#d40621;*/
/* ################## */
/* ################## */
/* ################## */
/* ################## */
.notificationComplianceContainer {
  width: 480px;
}
@media screen and (max-width: 905px) {
  .notificationComplianceContainer {
    width: 100%;
  }
}

.title {
  color: black;
}

.infoText {
  text-align: left;
  padding: 0 35px;
}
.infoText:first-of-type {
  margin-top: 40px;
}
.infoText:last-of-type {
  margin-bottom: 80px;
}

.toggleContainer {
  display: flex;
  justify-content: space-evenly;
  margin: 25px 0;
}

.sendButton {
  margin-top: 20px;
  width: 180px;
}

.error {
  font-size: small;
}

.bold {
  font-weight: bold;
}

button {
  margin: 10px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
